import React, { Component } from "react";
import firebase from "firebase/app";
import Input from "./Input/Input.base";
import Button from "./Button/Button.base";

import { auth } from "../Utils/firebase.auth";
import { snapShotToArray } from "../Utils/helpers";

import avatar from "../img/avatar.svg";

const style = {
  account: {
    marginBottom: "50px"
  },
  avatar: {
    width: "100px"
  },
  button: {
    margin: "20px 5px",
    width: "250px"
  },
  deleteInfo: { color: "red", fontStyle: "italic" },
  mailto: { color: "blue", textDecoration: "underline" }
};

export default class Account extends Component {
  constructor(props) {
    super(props);
    const { displayName, email, photoURL } = this.props.user;
    this.state = {
      pseudo: displayName,
      email: email,
      photoURL: photoURL,
      isAccountDeleteConfirmed: false
    };
  }

  updateUserSpeeches = () => {
    const { user } = this.props;
    const videosRef = firebase.database().ref("videos");
    videosRef.on("value", (snapshot) => {
      const videos = snapShotToArray(snapshot);
      const myVideos = videos.filter((video) => video.userId === user.uid);
      for (let video in myVideos) {
        firebase
          .database()
          .ref(`videos/${myVideos[video].id}`)
          .update({
            userName: this.state.pseudo,
            updatedAt: Date.now()
          });
      }
      window.location.reload();
    });
  };

  updateUser = (e) => {
    e.preventDefault();
    let currentUser = auth.currentUser;
    currentUser.updateProfile({
      displayName: this.state.pseudo
    });

    this.updateUserSpeeches();
  };

  handleChange = (e) => {
    let stateName = e.target.name.toLowerCase();
    this.setState({ [stateName]: e.target.value });
  };

  handleConfirmSuppr = () => {
    const { user } = this.props;
    let confirm = prompt(
      "Si vous êtes vraiment sûr de vouloir supprimer votre compte, inscrivez votre email et validez. "
    );
    confirm === user.email && this.setState({ isAccountDeleteConfirmed: true });
  };

  handleLogout = () => {
    auth.signOut();
  };

  render() {
    const { user } = this.props;
    const DeleteRequestMail = `mailto:${process.env.REACT_APP_SPEEKER_EMAIL}?subject=Demande de suppression compte utilisateur
      &body=Merci de bien vouloir supprimer mon compte Speeker ainsi que toutes mes données.
      %0D%0A
      %0D%0A Mon id : ${user.uid}
      %0D%0A Mon email : ${user.email}
      %0D%0A
      %0D%0ACordialement, ${user.displayName}.`;

    return (
      <div style={style.account}>
        <h2>Mon profil</h2>
        <div style={style}>
          <img
            src={this.state.photoURL ? this.state.photoURL : avatar}
            alt="avatar"
            width="100"
            height="100"
            style={style.avatar}
          />
          <div>
            <Input
              type="text"
              label="Pseudo"
              value={this.state.pseudo}
              onChange={(e) => this.handleChange(e)}
            />
          </div>
          <Button
            width="150"
            variant="outlined"
            type="submit"
            label="Valider"
            onClick={(e) => this.updateUser(e)}
            style={style.button}
          />
        </div>
        <Button
          label="Déconnexion"
          onClick={this.handleLogout}
          style={style.button}
        />

        <Button
          label="Supprimer mon Compte"
          color="secondary"
          onClick={() => this.handleConfirmSuppr()}
          style={style.button}
        />
        {this.state.isAccountDeleteConfirmed && (
          <div>
            <p style={style.deleteInfo}>
              Pour supprimer votre compte ainsi que toutes vos données, veuillez
              envoyer{" "}
              <a style={style.mailto} href={DeleteRequestMail} target="_blank" rel="noopener noreferrer">
                un mail à l'administrateur.
              </a>
            </p>
            <p>
              Cette action peut prendre jusqu'à 48 H. Vous recevrez un mail de
              confirmation après la suppression de votre compte.
            </p>
          </div>
        )}
      </div>
    );
  }
}
